<template>
    <div id="content" class="cf site-content">
        <div id="primary" class="full-width-page">
            <main id="main" class="site-main" role="main">
                <article id="post-16" class="post-16 page type-page status-publish hentry">
                    <header class="entry-header">
                    </header>
                    <!-- .entry-header -->
                    <div class="entry-content">
                        <div id="pl-16" class="panel-layout">
                            <div id="pg-16-0" class="panel-grid panel-no-style">
                                <div id="pgc-16-0-0" class="panel-grid-cell">
                                    <div id="panel-16-0-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="0">
                                        <div class="textwidget">
                                            <h1 style="text-align: center;">
                                                <span class="contact-headline" style="color: #000000;">
                                                    Thanks for visiting {{storeName}}...
                                                </span><br>
                                                <span class="contact-headline" style="color: #000000;" v-html="title">
                                                </span>
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pg-16-1" class="panel-grid panel-no-style">
                                <div id="pgc-16-1-0" class="panel-grid-cell">
                                    <div id="panel-16-1-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="1">
                                        <div class="textwidget">
                                            <p style="text-align: center;"><span class="" style="display:block;clear:both;height: 0px;padding-top: 16px;border-top-width:0px;border-bottom-width:0px;"></span>
                                            </p>
                                            <p>
                                                <a href="###" target="_blank" rel="attachment wp-att-272">
                                                    <img class="alignnone wp-image-315 size-full" src="/static/images/SF00201M-0027-F2k-e1469552354685.jpg" width="700" height="700">
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="pgc-16-1-1" class="panel-grid-cell">
                                    <div id="panel-16-1-1-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="2">
                                        <div class="textwidget">
                                            <p></p>
                                            <div role="form" class="wpcf7" id="wpcf7-f32-p16-o1" dir="ltr" lang="en-US">
                                                <div class="screen-reader-response"></div>
                                                <form method="post" v-on:submit.prevent="onSubmit" class="wpcf7-form" novalidate="novalidate">
                                                    <p>Your Name (required)
                                                        <br>
                                                        <span class="wpcf7-form-control-wrap your-name">
                                                        <input name="name" v-model="name" size="40" autocomplete="off"  class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" type="text" required>
                                                        </span>
                                                    </p>
                                                    <p>Your Email (required)
                                                        <br>
                                                        <span class="wpcf7-form-control-wrap your-email"><input name="email" v-model="email" size="40" class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email" autocomplete="off" required type="email"></span>
                                                    </p>
                                                    <p>Subject
                                                        <br>
                                                        <span class="wpcf7-form-control-wrap your-subject"><input name="subject"  autocomplete="off"  v-model="subject" size="40" class="wpcf7-form-control wpcf7-text" required type="text"></span>
                                                    </p>
                                                    <p>Your Message
                                                        <br>
                                                        <span class="wpcf7-form-control-wrap your-message">
                                                        <textarea name="message" v-model="message" autocomplete="off" cols="40" rows="10" class="wpcf7-form-control wpcf7-textarea" required >
                                                        </textarea>
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <input :value="isDisabled===true ? 'Send...' : isDisabled===false ? 'Send' : 'Done'" class="wpcf7-form-control wpcf7-submit" type="submit" :disabled="isDisabled">
                                                    </p>
                                                    <div class="wpcf7-response-output wpcf7-display-none"></div>
                                                </form>
                                            </div>
                                            <p></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pg-16-2" class="panel-grid panel-no-style">
                                <div class="panel-grid-cell">
                                    <div id="panel-16-2-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="3">
                                        <div class="textwidget" v-html="left_content">
                                        </div>
                                    </div>
                                </div>
                                <div id="pgc-16-2-1" class="panel-grid-cell">
                                    <div id="panel-16-2-1-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="4">
                                        <div class="textwidget" v-html="right_content">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- .entry-content -->
                </article>
                <!-- #post-## -->
            </main>
            <!-- #main -->
        </div>
    </div>
</template>
<style type="text/css" media="all" id="siteorigin-panels-layouts-head">
    /* Layout 16 */
    #pgc-16-0-0 {
        width: 100%;
        width: calc(100% - (0 * 30px))
    }
    #pl-16 #panel-16-0-0-0,
    #pl-16 #panel-16-1-0-0,
    #pl-16 #panel-16-1-1-0,
    #pl-16 #panel-16-2-0-0,
    #pl-16 #panel-16-2-1-0 {} #pg-16-0,
    #pg-16-1,
    #pl-16 .so-panel {
        margin-bottom: 30px
    }
    #pgc-16-1-0 {
        width: 50.0129%;
        width: calc(50.0129% - (0.499871134021 * 30px))
    }
    #pgc-16-1-1 {
        width: 49.9871%;
        width: calc(49.9871% - (0.500128865979 * 30px))
    }
    #pgc-16-2-0,
    #pgc-16-2-1 {
        width: 50%;
        width: calc(50% - (0.5 * 30px))
    }
    #pl-16 .so-panel:last-child {
        margin-bottom: 0px
    }
    @media (max-width: 780px) {
        #pg-16-0.panel-no-style,
        #pg-16-0.panel-has-style > .panel-row-style,
        #pg-16-1.panel-no-style,
        #pg-16-1.panel-has-style > .panel-row-style,
        #pg-16-2.panel-no-style,
        #pg-16-2.panel-has-style > .panel-row-style {
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column
        }
        #pg-16-0 .panel-grid-cell,
        #pg-16-1 .panel-grid-cell,
        #pg-16-2 .panel-grid-cell {
            margin-right: 0
        }
        #pg-16-0 .panel-grid-cell,
        #pg-16-1 .panel-grid-cell,
        #pg-16-2 .panel-grid-cell {
            width: 100%
        }
        #pgc-16-1-0,
        #pgc-16-2-0 {
            margin-bottom: 30px
        }
        #pl-16 .panel-grid-cell {
            padding: 0
        }
        #pl-16 .panel-grid .panel-grid-cell-empty {
            display: none
        }
        #pl-16 .panel-grid .panel-grid-cell-mobile-last {
            margin-bottom: 0px
        }
    }
</style>
<script>
    import api from '../api.js'
    // import loading_gif from '@/assets//home/images/blue_loading.gif'
    export default {
    	props:["storeName"],
        data() {
            return {
                title: "",
                left_content:"",
                right_content:"",
                name:"",
                email:"",
                subject:"",
                message:"",
                isDisabled:false,
            }
        },
        async mounted() {
            const res = await api.get('/api/article/2')
            const res2 = await api.get('/api/article/4')
            this.title = res.data.message.item.title;
            this.left_content = res.data.message.item.content;
            this.right_content = res2.data.message.item.content;
        },
        methods: {
             onSubmit:async function() {
                if (!this.name) {
                    this.$dialog.alert("name is necessary");
                    return;
                } else if(!this.email) {
                    this.$dialog.alert("email is necessary");
                    return;
                }
                this.isDisabled = true;
                const res = await api.post("/api/contact", {name: this.name, email: this.email, subject: this.subject, content: this.message})
                if(res.data.code == 1) {
                    let message = {
                      title: 'Sumitted successfully',
                      body: 'Thanks for you message, we do appreicate and will read it whenever we are on work!',
                    };
                    this.isDisabled = 'true';
                    this.$dialog.alert(message).then(function(){

                    });
                } else {
                    this.isDisabled = false;
                    let message = {
                      title: 'Failed to submit',
                      body:'',
                    };
                    let respType = typeof(res.data.message);
                    if (respType == "string") {
                        message.body = res.data.message;
                    } else if(respType == "object") {
                        Object.keys(res.data.message).forEach(function(key) {
                            message.body += res.data.message[key] + '<br><br>';
                        });
                    }
                    this.$dialog.alert(message).then(function(){

                    });
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue